<template>
  <div class="product-wrapper">
    <div class="banner-container">
      <div class="banner-item">
        <img class="bg" src="../../assets/images/banner-bg.png"/>
        <div class="content">
          <div class="title">产品与服务</div>
          <div class="title">智慧村社管理平台</div>
          <div class="subtitle"></div>
          <div class="desc">
            还在为这些问题而烦恼吗？
            <br/>
           村社基层难以治理；民情民生没有反馈通道；基层工作人员工作压力太大等；
            <br/>
            智慧村社管理平台为您提供一站式解决方案！
          </div>
        </div>
      </div>
    </div>
    <div class="body-container">
      <div class="intro-container bg-gray">
        <div class="intro-con">
          <div class="content content-about">
            <div class="about-left">
              <div class="image-single">
                <!-- <img src="../../assets/images/hqms/hqms-1.png" style="width: 85%;"/> -->
              </div>
            </div>
            <div class="about-right">
              <div class="about-title" style="text-align:center;">智慧村社管理平台</div>
              <div class="about-desc" style="margin-left:111px">
                提升村社基层治理水平，为基层治理提供管理抓手；搭建公共服务模块，为群众提供便民服务；建立村务管理系统，减轻基层工作人员工作压力。
                <br/>
              从产业兴旺、生态宜居、乡风文明、公益奉献、奉公守法五个层面，对居民进行量化评价，评价结果应用于居民自治、便民服务、村务管理、荣誉评定等，进一步弘扬社会主义价值观，构建“自治为基础、法治为保障、德治为引领”的“三治融合”村社治理体系。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container">
        <div class="intro-item">
          <div class="intro-con">
            <div class="title">智慧村社总体架构</div>
            <!-- <div class="subtitle">
                支持多种签到（刷健康卡，医保卡，身份证）
            </div> -->
            <div class="content">
              <div class="image-single">
                <img src="../../assets/images/iv/iv-1.png"/>
              </div>
            </div>
          </div>
            <div class="intro-con">
            <div class="title">应用广泛</div>
            <div class="content">
              <div class="image-single">
                <img src="../../assets/images/iv/iv-2.png"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container bg-gray">
        <div class="intro-con">
          <div class="title">智慧村社平台优势</div>
          <div class="content content-box">
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/iv/merit-1.png"/>
                <div class="box-title">管理架构清晰</div>
                <div class="box-desc" style="text-align:center;">
                  管理层级可按市三级作战单元设置，做到穿透式线上管理，一级管二级，二级管三级，也可一级管三级。
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/iv/merit-2.png"/>
                <div class="box-title">考核功能强大</div>
                <div class="box-desc">
                  考核指标全面、灵活，管理层级可设置下一层级的考核模型；考核公开、公正，村规民约线上化、指标化，做到加减分有依据、有证据；考核对象广泛。
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/iv/merit-3.png"/>
                <div class="box-title">服务功能多样</div>
                <div class="box-desc">
                 民情反馈、投票问卷、党建活动、在线诊疗、健康申报、政策资讯、出入村卡口、在线商城、出租人员管理等十几项便民服务功能，后续根据需求还在不断添加中。
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/iv/merit-4.png"/>
                <div class="box-title">考核惩奖制度</div>
                <div class="box-desc">
                 以激励为主、惩戒为辅的原则，整理了26条奖惩约束清单，其中20条为激励措施。对信用考核评价优秀的居民，给予优厚的奖励政策。对信用考核评价较差的居民，给予一定的惩罚措施。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product'
}
</script>

<style scoped lang="less">
  @import "../../assets/css/variable";
  .body-container {}
  .nav-container {
    width: @width-max;
    margin: 0 auto;
    padding: 26px 0;
    display: flex;
    align-items: center;
    .nava {
      padding: 15px;
      font-size: 16px;
      flex: 1;
      text-align: center;
    }
  }
  .intro-container .intro-con .content.content-box .box-con .box-item {
      height: 290px;
  }
  .box-desc {
      text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/product4.vue